import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";


const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
];

const departmentOptions = [
  { label: "Admin", value: "Admin" },
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "PACKING", value: "PACKING" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "QUALITY", value: "QUALITY" },
  { label: "ANCILLARY", value: "ANCILLARY" },
];

const AttendanceReportMonthWise = () => {
  const formik = useFormik({
    initialValues: {
      year: "",
      month: "",
      department: "",
      category: "",
      employeeCode: "",
      employeeName: "",
    },
    validationSchema: Yup.object({
      month: Yup.string().required("Month is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values", values);
    },
  });

  const [data] = useState([
    {
      code: "001",
      name: "ARUN",
      month: "January",
      daysWorked: "27.00",
      eligibleLeave: "0.0",
      casualLeave: "0.0",
      lop: "0.0",
      permission: "0 Hrs 0 Minutes",
      late: "0",
    },
    {
      code: "002",
      name: "VIGNESH",
      month: "January",
      daysWorked: "27.00",
      eligibleLeave: "0.0",
      casualLeave: "0.0",
      lop: "0.0",
      permission: "0 Hrs 0 Minutes",
      late: "0",
    },
    {
      code: "003",
      name: "ULAGURAJ",
      month: "January",
      daysWorked: "27.00",
      eligibleLeave: "0.0",
      casualLeave: "0.0",
      lop: "0.0",
      permission: "0 Hrs 0 Minutes",
      late: "0",
    },
  ]);

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Employee Code", accessor: "code" },
    { Header: "Employee Name", accessor: "name" },
    { Header: "Month", accessor: "month" },
    { Header: "Total Days Worked", accessor: "daysWorked" },
    { Header: "Eligible Leave", accessor: "eligibleLeave" },
    { Header: "Casual Leave", accessor: "casualLeave" },
    { Header: "Loss Of Pay", accessor: "lop" },
    { Header: "Total Permissions", accessor: "permission" },
    { Header: "Total Late", accessor: "late" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Month Wise Report" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Year</Label>
                  <CustomDatePicker
                    name="year"
                    value={formik.values.year}
                    onChange={(val) => formik.setFieldValue("year", val)}
                    onBlur={formik.handleBlur}
                    placeholderText="Select Year"
                  />
                </Col>

                <Col md={4}>
                  <Label>
                    Month <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="month"
                    value={formik.values.month}
                    onChange={(val) => formik.setFieldValue("month", val)}
                    onBlur={formik.handleBlur}
                    placeholderText="Select Month"
                  />
                  {formik.touched.month && formik.errors.month && (
                    <div className="text-danger mt-1">{formik.errors.month}</div>
                  )}
                </Col>

                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>Employee Code</Label>
                  <input
                    type="text"
                    name="employeeCode"
                    className="form-control"
                    value={formik.values.employeeCode}
                    onChange={formik.handleChange}
                  />
                </Col>

                <Col md={4}>
                  <Label>Employee Name</Label>
                  <input
                    type="text"
                    name="employeeName"
                    className="form-control"
                    value={formik.values.employeeName}
                    onChange={formik.handleChange}
                  />
                </Col>

                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportMonthWise;
